module.exports = __webpack_public_path__ + "static/media/40.ccf44dc6.jpg";